/* eslint-disable camelcase */
import type { EligibilityCoupon } from '@/domains/loyalty/modules/CouponEligibility/interfaces/EligibilityCoupon';
import type { ICouponFromApi } from '@/domains/productDiscovery/Recommendation/modules/ProductBundle/components/Coupon/services/fetchBundleCoupons';

export const processCouponDetails = (
  couponFromApi: ICouponFromApi,
): EligibilityCoupon => {
  const { code, value, end_time, is_percentage, min_price } = couponFromApi;

  return {
    code,
    amount: value,
    endTime: end_time,
    isPercentage: is_percentage,
    minPrice: min_price,
  };
};

export const processBundleCoupons = (
  coupons: ICouponFromApi[],
  bundlePrice: number,
): EligibilityCoupon | false => {
  // Get applicable coupons based on min price
  const validCoupons = coupons.filter(
    (coupon) => coupon.min_price < bundlePrice,
  );

  // Percentage coupons have priority over maximum value
  const percentageCoupons = validCoupons.filter(
    (coupon) => coupon.is_percentage,
  );

  const couponsToUse =
    percentageCoupons.length > 0 ? percentageCoupons : validCoupons;

  // Find the best coupons among the coupons to use
  const betterCoupon =
    couponsToUse.length > 0 &&
    couponsToUse.reduce(
      (prev: ICouponFromApi | undefined, current: ICouponFromApi) =>
        prev && prev.value > current.value ? prev : current,
    );

  return betterCoupon && processCouponDetails(betterCoupon);
};
